import React from 'react';
import classNames from 'classnames';
import 'styles/utils/MaterialUITextField.styl';

/**
 * Implement a material-ui/TextField clone that supports rendering children in the main <div/>
 */
export default class MaterialUITextField extends React.Component {
  render() {
    const className = classNames('material-ui-text-field', this.props.className);
    return (
      <div className={className} style={this.props.style}>
        <input type="text" name="name" value={this.props.value} onChange={this.props.onChange} />
        {this.props.children}
      </div>
    );
  }
}
